/* eslint-disable max-len */
import { extend, isNullOrUndefined } from '@syncfusion/ej2-base';
import { hideSpinner, showSpinner } from '@syncfusion/ej2-popups';
export class Export {
    constructor(parent) {
        this.parent = parent;
        this.addEventListener();
    }
    destroy() {
        if (this.parent.isDestroyed) {
            return;
        }
        this.removeEventListener();
    }
    addEventListener() {
        this.parent.on('export', this.export, this);
        this.parent.on('destroyed', this.destroy, this);
    }
    removeEventListener() {
        this.parent.off('export', this.export);
        this.parent.off('destroyed', this.destroy);
    }
    export(args) {
        this.parent.notify('toolbar', { prop: 'refreshShapeDrawing', onPropertyChange: false });
        this.updatePvtVar();
        switch (args.prop) {
            case 'export':
                this.exportImg(args.value['type'], args.value['fileName'], args.value['imgQuality']);
                break;
            case 'exportToCanvas':
                this.exportToCanvas(args.value['object']);
                break;
            case 'updateSaveContext':
                this.updateSaveContext(args.value['context']);
                break;
            case 'setImageQuality':
                this.imageQuality = args.value['value'];
                break;
            case 'drawAnnotation':
                this.drawAnnotation(args.value['context'], args.value['ratio']);
                break;
            case 'downScaleImgCanvas':
                this.downScaleImgCanvas(args.value['canvas'], args.value['width'], args.value['height']);
                break;
        }
    }
    getModuleName() {
        return 'export';
    }
    updatePvtVar() {
        const parent = this.parent;
        if (parent.lowerCanvas) {
            this.lowerContext = parent.lowerCanvas.getContext('2d');
        }
    }
    exportImg(type, fileName, imgQuality) {
        const parent = this.parent;
        const obj = { fileName: '' };
        parent.notify('draw', { prop: 'getFileName', onPropertyChange: false, value: { obj: obj } });
        const imageName = obj['fileName'];
        if (!parent.disabled && parent.isImageLoaded) {
            parent.notify('shape', { prop: 'applyActObj', onPropertyChange: false, value: { isMouseDown: null } });
            const obj = { canvasFilter: this.parent.canvasFilter };
            this.lowerContext.filter = obj['canvasFilter'];
            type = type ? type : 'Png';
            parent.notify('shape', { prop: 'redrawActObj', onPropertyChange: false,
                value: { x: null, y: null, isMouseDown: null } });
            const beforeSave = { cancel: false, fileName: fileName ? fileName : imageName,
                fileType: type, imageQuality: imgQuality };
            parent.trigger('beforeSave', beforeSave);
            this.beforeSaveEvent(beforeSave, type, fileName, imageName, imgQuality);
        }
    }
    beforeSaveEvent(observableSaveArgs, type, fileName, imageName, imgQuality) {
        const parent = this.parent;
        if (!observableSaveArgs.cancel) {
            parent.currObjType.isSave = true;
            fileName = observableSaveArgs.fileName ? observableSaveArgs.fileName : fileName;
            const lowerCaseType = type.toLowerCase();
            fileName = fileName || imageName;
            if (lowerCaseType === 'svg') {
                this.toSVGImg(fileName);
            }
            else {
                this.toBlobFn(fileName, lowerCaseType, observableSaveArgs.imageQuality || imgQuality);
            }
            const saved = { fileName: fileName ? fileName : imageName, fileType: type };
            parent.trigger('saved', saved);
            const actionArgs = { action: 'save', actionEventArgs: saved };
            parent.triggerEditCompleteEvent(actionArgs);
            parent.notify('toolbar', { prop: 'refresh-main-toolbar', onPropertyChange: false });
            parent.lowerCanvas.style.left = parent.upperCanvas.style.left = '';
            parent.lowerCanvas.style.top = parent.upperCanvas.style.top = '';
            parent.lowerCanvas.style.maxWidth = parent.upperCanvas.style.maxWidth = '';
            parent.lowerCanvas.style.maxHeight = parent.upperCanvas.style.maxHeight = '';
        }
    }
    toSVGImg(fileName) {
        const parent = this.parent;
        showSpinner(parent.element);
        parent.element.style.opacity = '0.5';
        const tempCanvas = this.exportToCanvas();
        const dataUrl = tempCanvas.toDataURL();
        hideSpinner(parent.element);
        parent.element.style.opacity = '1';
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('width', tempCanvas.style.maxWidth);
        svg.setAttribute('height', tempCanvas.style.maxHeight);
        const XLinkNS = 'http://www.w3.org/1999/xlink';
        const img = document.createElementNS('http://www.w3.org/2000/svg', 'image');
        img.setAttributeNS(null, 'height', tempCanvas.height.toString());
        img.setAttributeNS(null, 'width', tempCanvas.width.toString());
        img.setAttributeNS(XLinkNS, 'xlink:href', dataUrl);
        svg.appendChild(img);
        const prefix = 'data:image/svg+xml;base64,';
        const header = '<svg' + ' xmlns="http://www.w3.org/2000/svg"' + ' xmlns:xlink="http://www.w3.org/1999/xlink"'
            + ` width="${tempCanvas.width}"` + ` height="${tempCanvas.height}"` + '>';
        const footer = '</svg>';
        const body = svg.innerHTML;
        const data = header + body + footer;
        const svgDataUrl = prefix + btoa(data);
        if (fileName === null) {
            return svgDataUrl;
        }
        else {
            this.downloadImg(svgDataUrl, fileName + '.' + 'svg');
            return null;
        }
    }
    toBlobFn(fileName, type, imgQuality) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const proxy = this;
        const parent = this.parent;
        showSpinner(parent.element);
        parent.element.style.opacity = '0.5';
        if (!isNullOrUndefined(imgQuality)) {
            imgQuality = imgQuality > 1 ? 1 : (imgQuality <= 0 ? 0.01 : imgQuality);
            this.imageQuality = imgQuality ? imgQuality : null;
        }
        const tempCanvas = this.exportToCanvas();
        const imagetype = (type === 'jpeg' ? 'image/jpeg' : (type === 'webp' ? 'image/webp' : 'image/png'));
        // eslint-disable-next-line @typescript-eslint/tslint/config
        tempCanvas.toBlob(function (blob) {
            const blobUrl = URL.createObjectURL(blob);
            proxy.downloadImg(blobUrl, fileName + '.' + type);
            hideSpinner(parent.element);
            parent.element.style.opacity = '1';
        }, imagetype, this.imageQuality ? this.imageQuality : null);
    }
    exportToCanvas(object) {
        const parent = this.parent;
        let width;
        let height;
        const tempCropObj = extend({}, parent.cropObj, {}, true);
        const tempObj = { currObj: {} };
        parent.notify('filter', { prop: 'getCurrentObj', onPropertyChange: false, value: { object: tempObj } });
        const prevObj = tempObj['currObj'];
        prevObj.objColl = extend([], parent.objColl, [], true);
        prevObj.pointColl = extend([], parent.pointColl, [], true);
        prevObj.afterCropActions = extend([], parent.afterCropActions, [], true);
        const selPointCollObj = { selPointColl: null };
        parent.notify('freehand-draw', { prop: 'getSelPointColl', onPropertyChange: false,
            value: { obj: selPointCollObj } });
        if (this.parent.aspectWidth) {
            parent.notify('undo-redo', { prop: 'setPreventUR', value: { bool: true } });
            parent.notify('toolbar', { prop: 'resizeClick', value: { bool: false } });
            parent.okBtn();
            if (parent.transform.degree % 90 === 0 && parent.transform.degree % 180 !== 0) {
                width = this.parent.aspectHeight;
                height = this.parent.aspectWidth;
            }
            else {
                width = this.parent.aspectWidth;
                height = this.parent.aspectHeight;
            }
            parent.notify('undo-redo', { prop: 'setPreventUR', value: { bool: false } });
        }
        else if (parent.currSelectionPoint) {
            width = parent.img.srcWidth;
            height = parent.img.srcHeight;
        }
        else {
            width = parent.baseImgCanvas.width;
            height = parent.baseImgCanvas.height;
        }
        const obj = { width: 0, height: 0 };
        parent.notify('crop', { prop: 'calcRatio', onPropertyChange: false,
            value: { obj: obj, dimension: { width: width, height: height } } });
        const ratio = obj;
        const tempContextFilter = this.lowerContext.filter;
        // Manipulating blur value
        if (this.lowerContext.filter !== 'none') {
            const splitWords = this.lowerContext.filter.split(' ');
            let value = parseFloat(splitWords[5].split('(')[1]);
            value *= ((ratio.width + ratio.height) / 2);
            splitWords[5] = 'blur(' + value + 'px)';
            this.lowerContext.filter = splitWords.join(' ');
        }
        const tempCanvas = parent.createElement('canvas', {
            id: parent.element.id + '_tempCanvas', attrs: { name: 'canvasImage' }
        });
        const tempContext = tempCanvas.getContext('2d');
        tempCanvas.width = width;
        tempCanvas.height = height;
        const dimObj = { width: 0, height: 0 };
        parent.notify('transform', { prop: 'calcMaxDimension', onPropertyChange: false,
            value: { width: width, height: height, obj: dimObj } });
        const maxDimension = dimObj;
        tempCanvas.style.maxWidth = maxDimension.width + 'px';
        tempCanvas.style.maxHeight = maxDimension.height + 'px';
        const temp = this.lowerContext.filter;
        tempContext.filter = this.lowerContext.filter;
        this.downScaleImgCanvas(tempContext, width, height);
        this.lowerContext.filter = temp;
        if (parent.transform.degree !== 0 || parent.transform.currFlipState !== '' || parent.transform.straighten !== 0) {
            this.updateSaveContext(tempContext);
            this.exportTransformedImage(tempContext);
        }
        if (parent.isSafari) {
            parent.notify('filter', { prop: 'apply-filter', onPropertyChange: false, value: { context: tempContext } });
        }
        this.drawAnnotation(tempContext, ratio);
        if (parent.isCircleCrop) {
            parent.notify('crop', { prop: 'cropCircle', onPropertyChange: false,
                value: { context: tempContext, isSave: true, isFlip: null } });
        }
        this.updateFrame(tempContext, true);
        this.lowerContext.filter = tempContextFilter;
        parent.canvasFilter = tempContextFilter;
        if (object) {
            object['canvas'] = tempCanvas;
        }
        if (parent.aspectWidth) {
            parent.objColl = [];
            parent.pointColl = [];
            parent.freehandCounter = 0;
            parent.notify('freehand-draw', { prop: 'setSelPointColl', onPropertyChange: false,
                value: { obj: { selPointColl: [] } } });
            parent.notify('draw', { prop: 'setCurrentObj', onPropertyChange: false, value: { obj: prevObj } });
            prevObj.selPointColl = extend([], selPointCollObj['selPointColl'], [], true);
            parent.notify('freehand-draw', { prop: 'setSelPointColl', onPropertyChange: false,
                value: { obj: { selPointColl: prevObj.selPointColl } } });
            parent.cropObj = tempCropObj;
            parent.objColl = extend([], prevObj.objColl, [], true);
            parent.pointColl = extend([], prevObj.pointColl, [], true);
            parent.freehandCounter = parent.pointColl.length;
            parent.transform.straighten = 0;
            this.lowerContext.filter = 'none';
            parent.notify('shape', { prop: 'drawAnnotations', onPropertyChange: false,
                value: { ctx: this.lowerContext, shape: 'zoom', pen: 'zoom', isPreventApply: null } });
            this.lowerContext.filter = prevObj.filter;
            parent.notify('draw', { prop: 'clearOuterCanvas', onPropertyChange: false, value: { context: this.lowerContext } });
            if (parent.isCircleCrop || (parent.currSelectionPoint && parent.currSelectionPoint.shape === 'crop-circle')) {
                parent.notify('crop', { prop: 'cropCircle', onPropertyChange: false,
                    value: { context: this.lowerContext, isSave: null, isFlip: null } });
            }
        }
        return tempCanvas;
    }
    drawAnnotation(tempContext, ratio) {
        const parent = this.parent;
        const tempObjColl = extend([], parent.objColl, [], true);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const tempPointColl = extend([], parent.pointColl, [], true);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const nonRedact = parent.shapeColl.filter((item) => item.shape !== 'redact');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const redact = parent.shapeColl.filter((item) => item.shape === 'redact');
        parent.shapeColl = redact.concat(nonRedact);
        for (let i = 0; i < parent.shapeColl.length; i++) {
            if (parent.shapeColl[i].order) {
                if (parent.shapeColl[i].currIndex && parent.shapeColl[i].currIndex.indexOf('shape') > -1) {
                    parent.objColl = [];
                    parent.objColl.push(extend({}, parent.shapeColl[i], {}, true));
                    this.drawShape(tempContext, ratio);
                }
                else if (parent.shapeColl[i].id && parent.shapeColl[i].id.indexOf('pen') > -1) {
                    parent.pointColl = [];
                    parent.freehandCounter = 0;
                    parent.pointColl.push(extend({}, parent.shapeColl[i], {}, true));
                    parent.freehandCounter = parent.pointColl.length;
                    this.drawPen(tempContext, ratio);
                }
            }
        }
        parent.objColl = tempObjColl;
        parent.pointColl = tempPointColl;
        parent.freehandCounter = parent.pointColl.length;
    }
    drawShape(tempContext, ratio) {
        const parent = this.parent;
        if (parent.objColl.length > 0) {
            const temp = tempContext.filter;
            tempContext.filter = 'none';
            const indexObj = { index: null };
            parent.notify('shape', { prop: 'getSmallestIndex', onPropertyChange: false, value: { obj: indexObj } });
            let index = indexObj['index'];
            const objColl = extend([], parent.objColl, [], true);
            const tempObjColl = extend([], parent.objColl, [], true);
            while (objColl.length > 0) {
                let found = false;
                for (let i = 0; i < objColl.length; i++) {
                    const currentObj = objColl[i];
                    if (isNullOrUndefined(currentObj.order)) {
                        objColl.splice(i, 1);
                        i--;
                        continue;
                    }
                    if (currentObj.order === index) {
                        const temp = tempContext.filter;
                        tempContext.filter = 'none';
                        const currObj = objColl[i];
                        const activePoint = currObj.activePoint;
                        // Subtracting destination left and top points
                        activePoint.startX -= parent.img.destLeft;
                        activePoint.startY -= parent.img.destTop;
                        activePoint.endX -= parent.img.destLeft;
                        activePoint.endY -= parent.img.destTop;
                        activePoint.width = activePoint.endX - activePoint.startX;
                        activePoint.height = activePoint.endY - activePoint.startY;
                        // Manipulating points
                        activePoint.startX *= ratio.width;
                        activePoint.startY *= ratio.height;
                        activePoint.endX *= ratio.width;
                        activePoint.endY *= ratio.height;
                        activePoint.width = activePoint.endX - activePoint.startX;
                        activePoint.height = activePoint.endY - activePoint.startY;
                        currObj.strokeSettings.strokeWidth *= ((ratio.width + ratio.height) / 2);
                        if (currObj.shape === 'text') {
                            currObj.textSettings.fontSize *= ((ratio.width + ratio.height) / 2);
                        }
                        else if (currObj.shape === 'path') {
                            for (let l = 0; l < currObj.pointColl.length; l++) {
                                currObj.pointColl[l].x =
                                    (currObj.pointColl[l].x - parent.img.destLeft) * ratio.width;
                                currObj.pointColl[l].y =
                                    (currObj.pointColl[l].y - parent.img.destTop) * ratio.height;
                            }
                        }
                        else if (currObj.shape === 'image') {
                            parent.activeObj = extend({}, objColl[i], {}, true);
                            parent.notify('selection', { prop: 'upgradeImageQuality', onPropertyChange: false });
                            objColl[i] = extend({}, parent.activeObj, {}, true);
                        }
                        parent.notify('draw', { prop: 'drawObject', onPropertyChange: false, value: { canvas: 'saveContext', obj: objColl[i], isCropRatio: null,
                                points: null, isPreventDrag: true, saveContext: tempContext, isPreventSelection: null } });
                        tempContext.filter = temp;
                        parent.notify('shape', { prop: 'refreshActiveObj', onPropertyChange: false });
                        index++;
                        const indexBool = { bool: false };
                        parent.notify('shape', { prop: 'isIndexInObjColl', onPropertyChange: false, value: { obj: indexBool, index: index } });
                        if (!indexBool['bool']) {
                            index++;
                        }
                        objColl.splice(i, 1);
                        found = true;
                        break; // Exit the loop to start from the beginning
                    }
                }
                if (!found) {
                    break; // If no matching order was found, exit the loop
                }
            }
            tempContext.filter = temp;
            parent.notify('shape', { prop: 'refreshActiveObj', onPropertyChange: false });
            parent.objColl = tempObjColl;
        }
    }
    drawPen(tempContext, ratio) {
        const parent = this.parent;
        if (parent.freehandCounter > 0) {
            const widthObj = { penStrokeWidth: null };
            parent.notify('freehand-draw', { prop: 'getPenStrokeWidth', onPropertyChange: false, value: { obj: widthObj } });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const tempPointColl = extend({}, parent.pointColl, {}, true);
            for (let n = 0; n < parent.freehandCounter; n++) {
                parent.points = extend([], parent.pointColl[n].points, []);
                parent.notify('freehand-draw', { prop: 'setPointCounter', onPropertyChange: false, value: { value: 0 } });
                const len = parent.points.length;
                parent.pointColl[n].strokeWidth *= ((ratio.width + ratio.height) / 2);
                for (let l = 0; l < len; l++) {
                    parent.points[l].x = (parent.points[l].x - parent.img.destLeft) * ratio.width;
                    parent.points[l].y = (parent.points[l].y - parent.img.destTop) * ratio.height;
                }
            }
            parent.notify('freehand-draw', { prop: 'freehandRedraw', onPropertyChange: false,
                value: { context: tempContext, points: null } });
            parent.pointColl = tempPointColl;
            parent.notify('freehand-draw', { prop: 'setPenStrokeWidth', onPropertyChange: false, value: { value: widthObj['penStrokeWidth'] } });
        }
    }
    downScaleImgCanvas(ctx, width, height) {
        const parent = this.parent;
        const canvas = parent.baseImgCanvas;
        const img = parent.baseImg;
        const obj = { width: 0, height: 0 };
        parent.notify('transform', { prop: 'calcMaxDimension', onPropertyChange: false,
            value: { width: img.width, height: img.height, obj: obj, isImgShape: null } });
        const bgObj = { color: null };
        parent.notify('draw', { prop: 'getImageBackgroundColor', value: { obj: bgObj } });
        if (bgObj['color'] !== '') {
            ctx.fillStyle = bgObj['color'];
            ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);
        }
        if (obj['width'] > width && obj['height'] > height) {
            const tempCanvas = parent.createElement('canvas', {
                id: parent.element.id + '_downScaleCanvas', attrs: { name: 'canvasImage' }
            });
            tempCanvas.width = this.parent.img.srcWidth;
            tempCanvas.height = this.parent.img.srcHeight;
            tempCanvas.getContext('2d').drawImage(canvas, parent.img.srcLeft, parent.img.srcTop, parent.img.srcWidth, parent.img.srcHeight, 0, 0, tempCanvas.width, tempCanvas.height);
            parent.notify('draw', { prop: 'downScale', value: { canvas: tempCanvas, width: width, height: height } });
            ctx.drawImage(tempCanvas, 0, 0);
        }
        else {
            ctx.drawImage(parent.baseImgCanvas, parent.img.srcLeft, parent.img.srcTop, parent.img.srcWidth, parent.img.srcHeight, 0, 0, width, height);
        }
    }
    updateFrame(tempContext, isAnnotation) {
        if (this.parent.frameObj.type !== 'none') {
            const temp = tempContext.filter;
            tempContext.filter = 'none';
            this.parent.notify('draw', { prop: 'applyFrame', value: { ctx: tempContext, frame: this.parent.frameObj.type, preventImg: isAnnotation } });
            tempContext.filter = temp;
        }
    }
    downloadImg(blob, fileName) {
        const a = document.createElement('a');
        a.href = blob;
        a.target = '_parent';
        a.download = fileName;
        (document.body || document.documentElement).appendChild(a);
        a.click();
        a.parentNode.removeChild(a);
    }
    exportTransformedImage(tempContext) {
        const parent = this.parent;
        const degree = parent.transform.degree;
        if (parent.rotateFlipColl.length > 0) {
            for (let i = 0, len = parent.rotateFlipColl.length; i < len; i++) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const flip = parent.rotateFlipColl[i];
                if (typeof flip === 'number') {
                    this.exportRotate(tempContext, flip);
                }
                else if (flip === 'horizontal') {
                    this.exportFlip(tempContext, true, false);
                }
                else if (flip === 'vertical') {
                    this.exportFlip(tempContext, false, true);
                }
            }
        }
        parent.transform.degree = degree;
    }
    exportRotate(tempContext, degree) {
        const parent = this.parent;
        tempContext.clearRect(0, 0, tempContext.canvas.width, tempContext.canvas.height);
        this.setMaxDim(parent.transform.degree, tempContext.canvas);
        tempContext.translate(tempContext.canvas.width / 2, tempContext.canvas.height / 2);
        tempContext.rotate(Math.PI / 180 * degree);
        tempContext.drawImage(parent.inMemoryCanvas, -tempContext.canvas.height / 2, -tempContext.canvas.width / 2, tempContext.canvas.height, tempContext.canvas.width);
        this.updateSaveContext(tempContext);
    }
    exportFlip(tempContext, flipHorizontal, flipVertical) {
        tempContext.clearRect(0, 0, tempContext.canvas.width, tempContext.canvas.height);
        if (flipHorizontal) {
            tempContext.translate(tempContext.canvas.width, 0);
            tempContext.scale(-1, 1);
        }
        if (flipVertical) {
            tempContext.translate(0, tempContext.canvas.height);
            tempContext.scale(1, -1);
        }
        tempContext.drawImage(this.parent.inMemoryCanvas, 0, 0);
        this.updateSaveContext(tempContext);
    }
    updateSaveContext(tempContext) {
        const inMemoryContext = this.parent.inMemoryCanvas.getContext('2d');
        tempContext.setTransform(1, 0, 0, 1, 0, 0);
        const imageData = tempContext.getImageData(0, 0, tempContext.canvas.width, tempContext.canvas.height);
        this.parent.inMemoryCanvas.width = imageData.width;
        this.parent.inMemoryCanvas.height = imageData.height;
        inMemoryContext.putImageData(imageData, 0, 0);
    }
    setMaxDim(degree, tempCanvas) {
        let newWidth;
        let newHeight;
        if (degree % 90 === 0 && degree % 180 !== 0) {
            if (isNullOrUndefined(this.parent.currSelectionPoint)) {
                newWidth = this.parent.baseImgCanvas.height;
                newHeight = this.parent.baseImgCanvas.width;
            }
            else {
                newWidth = this.parent.img.srcHeight;
                newHeight = this.parent.img.srcWidth;
            }
        }
        else if (degree % 180 === 0 || degree === 0) {
            if (isNullOrUndefined(this.parent.currSelectionPoint)) {
                newWidth = this.parent.baseImgCanvas.width;
                newHeight = this.parent.baseImgCanvas.height;
            }
            else {
                newWidth = this.parent.img.srcWidth;
                newHeight = this.parent.img.srcHeight;
            }
        }
        if (!isNullOrUndefined(this.parent.aspectWidth)) {
            newWidth = this.parent.aspectWidth;
            newHeight = this.parent.aspectHeight;
        }
        tempCanvas.width = newWidth;
        tempCanvas.height = newHeight;
        const obj = { width: 0, height: 0 };
        this.parent.notify('transform', { prop: 'calcMaxDimension', onPropertyChange: false,
            value: { width: newWidth, height: newHeight, obj: obj, isImgShape: null } });
        const maxDimension = obj;
        tempCanvas.style.maxWidth = maxDimension.width + 'px';
        tempCanvas.style.maxHeight = maxDimension.height + 'px';
    }
}
